<template>
  <div class="video-carousel">
    <Flicking :options="videoCarouselOptions" ref="videoCarousel" @move-end="setActiveDot($event)">
      <div v-for="(videoChunk, index) in videoChunks" class="video-carousel-card" :key="`video-chunk-${index + 1}`">
          <VideoItem 
            v-for="video in videoChunk" :key="video.id"
            :videoUrl="video.videoUrl"
            :title="video.title"
            :date="video.date"
          />
      </div>
    </Flicking>
    <div class="video-carousel-controls">
      <el-button type="text" class="arrow-carousel-control" @click="$refs.videoCarousel.next()"><i class="el-icon-arrow-left"></i></el-button>
      <div class="carousel-dots">
        <div class="carousel-dot" :class="{active: currentIndex === i}" v-for="(videoChunk, i) in videoChunks" :key="`dot-${i + 1}`" @click="$refs.videoCarousel.moveTo(i)"></div>
      </div>
      <el-button type="text" class="arrow-carousel-control" @click="$refs.videoCarousel.prev()"><i class="el-icon-arrow-right"></i></el-button>
    </div>
  </div>
</template>

<script>
  import { Flicking } from "@egjs/vue-flicking";
  import VideoItem from "@/components/cards/VideoItem";
  export default {
    name: 'video-carousel',
    components: {
      VideoItem,
      Flicking
    },
    props: {
      video: {
        type: Array
      }
    },
    data () {
      return {
        currentIndex: 0,
        videoCarouselOptions: {
          align: "prev",
          defaultIndex: 0,
          circular: true,
          inputType: ["touch", "mouse"],
          moveType: "snap",
          preventClickOnDrag: true
        }
      }
    },
    computed: {
      videoChunks() {
        if (!this.video) return null
        const videoChunks = this.getChunksArray(this.video, 2)
        return videoChunks
      },
    },
    methods: {
      setActiveDot() {
        this.currentIndex = this.$refs.videoCarousel.getStatus().index
      },
      getChunksArray(inputArray, chunks) {
        const chunksArray = inputArray.reduce((resultArray, item, index) => { 
          const chunkIndex = Math.floor(index/chunks)
          if(!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = []
          }
          resultArray[chunkIndex].push(item)
          return resultArray
        }, [])
        return chunksArray
      },
      onMoveEnd() { 
        const status = this.$refs.videoCarousel.getStatus()
        this.currentIndex = status.index
      }
    },
    mounted() {
      setTimeout(() => {
        this.setActiveDot()
      }, 1000)
      
    }
  }
</script>
